﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

// The header used by application pages.

import * as React from "react";
import { createUseStyles } from "react-jss";
import { useIntl } from "~base/Internationalization/IntlContext";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";

// ----------------------------------------------------------------------------------------------------
// Props
// ----------------------------------------------------------------------------------------------------

interface SessionInteractionButtonTextProps {
    textCode: string;
}

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

const useStyles = createUseStyles((theme: SoPNLConsilioTheme) => ({
    hiddenGridSpacer: {
        display: "grid",
        gridTemplateColumns: "100%",
        visibility: "hidden",
        height: 0,
    },
}));

// ----------------------------------------------------------------------------------------------------
// Component
// ----------------------------------------------------------------------------------------------------

export const SessionInteractionButtonText: React.FunctionComponent<
    SessionInteractionButtonTextProps
> = ({ textCode }) => {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <>
            <span>{intl.formatText(textCode)}</span>
            <div className={classes.hiddenGridSpacer}>
                <span>
                    {intl.formatText(
                        "SoPNL.UI.CustomerStartPage.Session.Action.View"
                    )}
                </span>
                <span>
                    {intl.formatText(
                        "SoPNL.UI.CustomerStartPage.Session.Action.Resume"
                    )}
                </span>
            </div>
        </>
    );
};
